import styled from '@emotion/styled'
import { SelectMenu } from 'components/patterns/Inputs'
import { RadioGroup } from 'components/patterns'

export const StyledSelectMenu = styled(SelectMenu)`
  .ant-select {
    display: flex;
    width: 100%;
  }
`

export const StyledRadioGroup = styled(RadioGroup)`
  margin-top: 20px;
  margin-bottom: 5px;
`
